// removed by extract-text-webpack-plugin
module.exports = {"main-calendar":"_2WP_m8NB8o5kFXFASaiuo","button":"I__OOPcucpFxmVTKht3IE","nav-button":"gy7hLPPzKIn5XVgwVEhfr","icon":"-niapMxjYMMFj3Id8vXxz","icon-next":"_1wW_bP16w8aidk6Ga_aQuO","icon-prev":"Vpv74leuAPjXlJ6qaKURr","calendar-header":"_2q78VoAjrZ72KFz4cVrHSf","title-header":"_1ZCql4ptg0Y6X4b_ju_WD3","header-text":"_13J0ZVsYJuhnDTUJTk6Wl0","today-label":"_2Qs3Ge46YJphBryzXvvwLW","month-label":"AlSte6ab4PjRQPLhIm4ey","button-container":"_2wNDco1xCgTl4umdiAo5-7","arrow":"_2C-LbCcCXLk7D8gjBjHGCC","event-button":"_2citNXAU_pO3O4JgU4oAzC","days-container":"_1heNZTg7DddzKc513OkhL6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/Calendar.mod.css
// module id = 1031
// module chunks = 0